import { Newsletter as NewsletterBase } from "@omni/components/components/Newsletter/newsletter";
import { NewsletterProps } from "@omni/types/components/props/newsletter.props";

import { FormComponent } from "./components/form/form.component";
import { TitleComponent } from "./components/title/title.components";

const NewsletterContainer = ({
    alignment,
    buttonText,
    helperText,
    isBold,
    link
}: NewsletterProps) => {
    return (
        <NewsletterBase
            alignment={alignment}
            buttonText={buttonText}
            helperText={helperText}
            isBold={isBold}
            link={link}
        >
            <TitleComponent />
            <FormComponent />
        </NewsletterBase>
    );
};

export { NewsletterContainer };
